import { RouterProvider, createBrowserRouter, Navigate } from 'react-router-dom'
import WalletHome from '@/views/WalletHome'
import BreadcrumbLayout from '@/components/BreadcrumbLayout'
import WalletDetail from './views/WalletDetail'
import History from '@/views/History'
import Setting from '@/views/Setting'
import Application from '@/views/Application'
import AutoSweep from '@/views/Application/components/AutoSweep'
import Login from '@/views/Login/index'
import Home from '@/views/Home/index'
import Layout from '@/views/Layout/index'
import Analyze from './views/Analyze'
const route = [
  {
    path: `/`,
    element: <Layout />,
    children: [
      {
        path: '/login',
        element: <Login />,
      },
      {
        path: '/home',
        element: <Home />,
      },
      {
        path: '/wallet',
        element: (
          <BreadcrumbLayout>
            <WalletHome />
          </BreadcrumbLayout>
        ),
      },
      {
        path: '/wallet/:walletKey',
        element: <WalletDetail />,
      },

      {
        path: '/history',
        element: <History />,
      },
      {
        path: '/setting',
        element: <Setting />,
      },
      {
        path: '/analyze',
        element: <Analyze />,
      },
      {
        path: '/application',
        element: (
          <BreadcrumbLayout>
            <Application />
          </BreadcrumbLayout>
        ),
      },
      {
        path: '/application/autoSweep',
        element: (
          <BreadcrumbLayout>
            <AutoSweep />
          </BreadcrumbLayout>
        ),
      },

      {
        path: '/',
        element: <Navigate to="/login" />,
      },
      {
        path: '*',
        element: <Navigate to="/wallet" />,
      },
    ],
  },
]
const router = createBrowserRouter(route, {
  basename: process.env.REACT_APP_ROUTER_BASE_ROUTER,
})

const ShRouter = () => <RouterProvider router={router} />

export default ShRouter
